import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["itemscope", "itemtype"]
const _hoisted_2 = ["id", "itemscope", "itemprop", "itemtype"]
const _hoisted_3 = ["itemprop", "onClick"]
const _hoisted_4 = ["itemscope", "itemprop", "itemtype"]
const _hoisted_5 = ["itemprop", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "vue-accordion",
    itemscope: _ctx.isRich,
    itemtype: _ctx.isRich ? 'https://schema.org/FAQPage' : undefined
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["item", { open: item.isOpen }]),
        id: item.slug,
        itemscope: _ctx.isRich,
        itemprop: _ctx.isRich ? 'mainEntity' : undefined,
        itemtype: _ctx.isRich ? 'https://schema.org/Question' : undefined
      }, [
        _createElementVNode("div", {
          class: "label",
          itemprop: _ctx.isRich ? 'name' : undefined,
          onClick: ($event: any) => (_ctx.toggle(item, index))
        }, _toDisplayString(item.title), 9, _hoisted_3),
        _createElementVNode("div", {
          class: "content",
          ref_for: true,
          ref: "content",
          itemscope: _ctx.isRich,
          itemprop: _ctx.isRich ? 'acceptedAnswer' : undefined,
          itemtype: _ctx.isRich ? 'https://schema.org/Answer' : undefined
        }, [
          _createElementVNode("div", {
            itemprop: _ctx.isRich ? 'text' : undefined,
            innerHTML: item.content
          }, null, 8, _hoisted_5)
        ], 8, _hoisted_4)
      ], 10, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}